import React from "react";
import ProfileTitle from "../../../../components/ProfileTitle";
import StandardTable, {StandardColumnsType} from "../../../../components/StandardTable";
import useAntTable from "../../../../utils/useAntTable";
import * as api from '../../../../apis/platforms/admin/baseData'
import {Button, Divider, Popconfirm, Space} from "antd";
import useFormModal from "../../../../utils/useFormModal";
import CountryEditModal from "./countryEditModal";
import {useRequest} from "ahooks";

export default function Country() {

    const {tableProps, refresh} = useAntTable(api.getCountries, {})

    const {setVisible, modalProps} = useFormModal({
        onRequest: api.editCountry,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    const {run: onDelete} = useRequest(api.deleteCountry, {
        manual: true,
        onSuccess: () => {
            refresh()
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '国家',
            dataIndex: 'country'
        },
        {
            title: '短名称',
            dataIndex: 'shortName'
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <Space split={<Divider type="vertical"/>}>
                    <a onClick={() => {
                        setVisible(true, record)
                    }}>编辑</a>
                    <Popconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                        <a>删除</a>
                    </Popconfirm>
                </Space>
            )
        }
    ]

    return (
        <div>
            <ProfileTitle>国家</ProfileTitle>
            <StandardTable {...tableProps} columns={columns} showCard={false} rowKey={'id'} toolbar={
                <Button type={'primary'} onClick={() => setVisible(true)}>新增</Button>
            }/>
            <CountryEditModal {...modalProps}/>
        </div>
    )
}
